module.exports = __webpack_public_path__ + "static/media/header__logo.716a8525.svg";